import { section } from './rows';
import { formatMeasure } from './units';

/** Live: what the vehicle is doing right now — event, motion, distances, environment, time. */
/** Raw `cx_event_type` values CerebrumX documents; any other value is shown as served. */
const KNOWN_EVENT_TYPES = ['trip_start', 'trip_ongoing', 'trip_end', 'OFFLINE'];

export const liveSections = (view, ctx) => {
	const { t } = ctx;
	const label = (key) => t(`oemDataModal_cerebrumx_live_${key}`);
	const yesNo = (value) => {
		if (value === undefined) return undefined;
		return t(value ? 'oemDataModal_yes' : 'oemDataModal_no');
	};
	const eventType = KNOWN_EVENT_TYPES.includes(view.eventType)
		? t(`oemDataModal_cerebrumx_eventType_${view.eventType}`)
		: view.eventType;
	// `cx_moving` stays false while the vehicle drives (P3-54278); a positive speed wins, like the map.
	const moving = view.moving === true || view.speed?.value > 0 ? true : view.moving;
	// GPS speed is served unitless; it shares the OBD speed's unit (same payload).
	const speedGps = view.speedGps && { ...view.speedGps, unit: view.speedGps.unit ?? view.speed?.unit };
	// Trip distance is served unitless; it shares the odometer's unit.
	const tripDistance = view.tripDistance === undefined
		? undefined
		: { value: view.tripDistance, unit: view.odometer?.unit };

	return [
		section('live', [
			{ key: 'eventType', icon: 'warning', label: label('eventType'), value: eventType },
			{ key: 'moving', icon: 'timeline', label: label('moving'), value: yesNo(moving) },
			{ key: 'gear', icon: 'settings', label: label('gear'), value: view.gear?.toUpperCase() },
			{ key: 'speed', icon: 'speed', label: label('speed'), value: formatMeasure(view.speed, ctx) },
			{ key: 'speedGps', icon: 'speed', label: label('speedGps'), value: formatMeasure(speedGps, ctx) },
			{
				key: 'acceleration',
				icon: 'timeline',
				label: label('acceleration'),
				value: formatMeasure(view.acceleration, ctx),
			},
			{
				key: 'lateralAcceleration',
				icon: 'timeline',
				label: label('lateralAcceleration'),
				value: formatMeasure(view.lateralAcceleration, ctx),
			},
			{ key: 'odometer', icon: 'speed', label: label('odometer'), value: formatMeasure(view.odometer, ctx) },
			{
				key: 'tripDistance',
				icon: 'route',
				label: label('tripDistance'),
				value: formatMeasure(tripDistance, ctx),
			},
			{
				key: 'ambientTemperature',
				icon: 'thermostat',
				label: label('ambientTemperature'),
				value: formatMeasure(view.ambientTemperature, ctx),
			},
			{
				key: 'lastReported',
				icon: 'schedule',
				label: label('lastReported'),
				value: view.eventTime && ctx.formatDateTime(view.eventTime),
			},
		]),
	];
};
